/*
 * NOTE: This is an auto-generated file created by Iconic.
 *
 * You should not need to edit this file directly; if you need to add/remove any
 * icon modules, you can rebuild it by running `yarn icons:make`.
 */
import * as React from 'react'

import VacasaWrapper from '../Wrapper'

const VacasaWatch: React.FunctionComponent = () => {
  return (
    <VacasaWrapper id="watch" viewBox="0 0 24 24">
      <g clipPath="url(#clip0_13_987)">
        <path
          d="M6.53 6.16202L6.844 2.73002C6.984 1.18502 8.278 0.00102268 9.83 2.26832e-05H14.176C15.733 -0.00597732 17.036 1.17902 17.176 2.72902L17.492 6.18202C19.037 7.64102 20.001 9.70702 20.001 12C20.001 14.303 19.028 16.379 17.471 17.838L17.157 21.27C17.017 22.821 15.714 24.006 14.161 24H9.835C8.278 24.006 6.975 22.821 6.835 21.271L6.52 17.828C4.969 16.369 4 14.298 4 12C4 9.69702 4.973 7.62102 6.53 6.16202ZM8.67 4.72402C9.684 4.25902 10.812 4.00002 12 4.00002C13.196 4.00002 14.331 4.26302 15.351 4.73302L15.184 2.91002C15.137 2.39302 14.703 1.99802 14.18 2.00002H9.831C9.314 2.00002 8.883 2.39502 8.836 2.91102L8.67 4.72402ZM8.186 7.36802C8.153 7.40002 8.117 7.43002 8.08 7.45802C6.806 8.55802 6 10.185 6 12.001C6 15.315 8.686 18.001 12 18.001C13.448 18.001 14.777 17.488 15.814 16.633C15.847 16.601 15.883 16.571 15.92 16.543C17.194 15.443 18 13.816 18 12C18 8.68602 15.314 6.00002 12 6.00002C10.552 6.00002 9.223 6.51302 8.186 7.36802ZM8.66 19.271L8.826 21.09C8.873 21.607 9.307 22.002 9.83 22H14.164C14.683 22.002 15.117 21.607 15.164 21.089L15.33 19.276C14.316 19.741 13.188 20 12 20C10.808 20 9.676 19.739 8.66 19.271ZM13 9.00002V11.586L14.207 12.793C14.598 13.184 14.598 13.817 14.207 14.207C13.816 14.597 13.183 14.598 12.793 14.207L11.293 12.707C11.105 12.519 11 12.265 11 12V9.00002C11 8.44802 11.448 8.00002 12 8.00002C12.552 8.00002 13 8.44802 13 9.00002Z"
          fill="currentColor"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_13_987">
          <rect width="24" height="24" fill="white"></rect>
        </clipPath>
      </defs>
    </VacasaWrapper>
  )
}

export default React.memo(VacasaWatch)
